import { gql } from '@apollo/client'

export const UNLINK_CHEWY_USER_AND_PETS = gql`
  mutation UnlinkChewyUserAndPets($businessId: ID, $clientId: ID!) {
    unlinkChewyUserAndPets(businessId: $businessId, clientId: $clientId)
  }
`
